(function () {
  'use strict';

  function initSection(root) {
    if (!root || root.dataset.svcInitialized) return;
    root.dataset.svcInitialized = 'true';

    var track = root.querySelector('[data-svc-track]');
    var prevBtn = root.querySelector('[data-svc-prev]');
    var nextBtn = root.querySelector('[data-svc-next]');
    var videoWraps = root.querySelectorAll('[data-svc-video-wrap]');

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var video = entry.target.querySelector('video');
            if (!video) return;
            if (entry.isIntersecting) {
              video.play().catch(function () {});
            } else {
              video.pause();
            }
          });
        },
        { root: track, threshold: 0.6 }
      );
      videoWraps.forEach(function (wrap) {
        observer.observe(wrap);
      });
    }

    root.querySelectorAll('[data-svc-sound-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var wrap = btn.closest('[data-svc-video-wrap]');
        var video = wrap ? wrap.querySelector('video') : null;
        if (!video) return;
        video.muted = !video.muted;
        btn.classList.toggle('is-unmuted', !video.muted);
      });
    });

    function scrollByItem(direction) {
      var item = track.querySelector('.svc-item');
      if (!item) return;
      var amount = item.getBoundingClientRect().width + 16;
      track.scrollBy({ left: direction * amount, behavior: 'smooth' });
    }
    if (prevBtn) prevBtn.addEventListener('click', function () { scrollByItem(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollByItem(1); });

    root.querySelectorAll('[data-svc-add-to-cart]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId || btn.disabled) return;
        var originalText = btn.textContent;
        btn.disabled = true;
        btn.textContent = '...';
        fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
        })
          .then(function (res) {
            if (!res.ok) throw new Error('add to cart failed');
            return res.json();
          })
          .then(function () {
            btn.textContent = 'Ajouté ✓';
            btn.classList.add('is-added');
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            setTimeout(function () {
              btn.textContent = originalText;
              btn.classList.remove('is-added');
              btn.disabled = false;
            }, 2000);
          })
          .catch(function () {
            btn.textContent = 'Erreur';
            setTimeout(function () {
              btn.textContent = originalText;
              btn.disabled = false;
            }, 2000);
          });
      });
    });
  }

  window.ShoppableVideoCarousel = { init: initSection };

  document.addEventListener('shopify:section:load', function (event) {
    initSection(event.target);
  });
})();
